<template>
  <Box class="chart-container">
    <h3>Aulas por veículo</h3>

    <div class="content">
      <form @submit.prevent="loadData">
        <Select legend="Placa" :options="vehiclesOptions" :modelValue="filterInputs.selectedVehicle"
          @update:modelValue="$event => (this.filterInputs.selectedVehicle = $event)"
          placeholder="Selecione uma placa" />

        <Period legend="Período" :firstModelValue="filterInputs.initialPeriod"
          :secondModelValue="filterInputs.finalPeriod"
          @update:firstModelValue="$event => (this.filterInputs.initialPeriod = $event)"
          @update:secondModelValue="$event => (this.filterInputs.finalPeriod = $event)" />

        <div class="buttons-box">
          <Button type="button" @handle:click="clearInputs" :disabled="loadingChart" text="Limpar" color="danger"
            :fill="false">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" :disabled="loadingChart" text="Consultar" color="primary">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="chart-container">
        <div v-if="loadingChart" class="d-flex justify-content-center align-items-center">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <canvas id="barChart" :hidden="loadingChart"></canvas>
      </div>
    </div>
  </Box>
</template>

<script>
import Chart from 'chart.js'
import urlApiV2 from '@/router/urlApiV2'
import * as spinners from 'epic-spinners'
import Box from '../core/Box.vue'
import Select from '../core/Select.vue'
import Period from '../core/Period.vue'
import Button from '../core/Button.vue'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'

export default {
  name: 'AulasPorVeiculo',
  components: {
    ...spinners,
    Box,
    Select,
    Period,
    Button,
    CloseCircleOutline,
    Magnify,
  },
  data() {
    return {
      chartInstance: null,
      data: [],
      vehiclesOptions: [],
      filterInputs: {
        initialPeriod: '',
        finalPeriod: '',
        selectedVehicle: {
          value: '',
          text: '',
        },
      },
      loadingChart: false,
    }
  },
  async created() {
    await Promise.all([
      this.loadData(),
      this.loadPlates(),
    ])
  },
  methods: {
    async loadData() {
      this.loadingChart = true

      const placa = typeof this.filterInputs.selectedVehicle == "string" ? '' : this.filterInputs.selectedVehicle ? this.filterInputs.selectedVehicle.value : ''

      await this.$http.get(`${urlApiV2}/dashboard/aulas/praticas/aulas-por-veiculo?placa=${placa}&periodo_i=${this.filterInputs.initialPeriod}&periodo_f=${this.filterInputs.finalPeriod}`)
        .then(response => {
          this.data = response.body.dados.dados_veiculos

          this.renderChart()
        })
        .catch(err => {
          this.launchToast(err)
        })
        .finally(() => {
          this.loadingChart = false
        })
    },
    renderChart() {
      const labels = this.data.map(item => item.placa)
      const data = this.data.map(item => item.total_aulas)

      const ctx = document.getElementById('barChart').getContext('2d')

      if (this.chartInstance) {
        this.chartInstance.destroy()
      }

      this.chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Total de Aulas',
              data: data,
              backgroundColor: '#FFC20E',
              borderColor: '#86868680',
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      })
    },
    async loadPlates() {
      await this.$http.get(`${urlApiV2}/veiculo`)
        .then(response => {
          this.vehiclesOptions = response.body.map(item => {
            return {
              value: item.placa,
              text: item.placa,
            }
          })
        })
        .catch(err => {
          this.launchToast(err)
        })
    },
    clearInputs() {
      this.filterInputs = {
        initialPeriod: '',
        finalPeriod: '',
        selectedVehicle: {
          value: '',
          text: '',
        },
      }
    },
    launchToast(mensagem) {
      this.$toasted.show(mensagem, {
        position: 'top-right',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h3 {
    margin: 0;
    font-size: 1.375rem;
    font-weight: 700;
    color: #202224;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 3rem;

    form {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 1rem;

      .buttons-box {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
    }

    .chart-container {
      height: 21rem;

      display: flex;
      align-items: center;
      justify-content: center;

      canvas {
        display: block;
      }
    }
  }
}
</style>
